const DSP_ORDER_STATUS_OPTIONS = [
  {
    label: "Delivering",
    value: "DELIVERING",
  },
  {
    label: "Ended",
    value: "ENDED",
  },
];

const DSP_ORDER_STATE_OPTIONS = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "INACTIVE",
  },
  {
    label: "Ended",
    value: "ENDED",
  },
];

const DSP_PRODUCT_CONVERSION_TYPE_OPTIONS = [
  {
    label: "Promoted",
    value: "Promoted",
  },
  {
    label: "Brand Halo",
    value: "Brand halo",
  },
];

export const DSP_ORDER_STATUS_FILTER = {
  label: "Status",
  id: "delivery_status",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: "All Statuses",
    },
    ...DSP_ORDER_STATUS_OPTIONS.map((status) => ({ label: status.label, value: status.value })),
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (order, filterValue) => {
    if (filterValue !== "all") {
      return order.delivery_status === filterValue;
    }
    return true;
  },
};

export const DSP_ORDER_STATE_FILTER = {
  label: "State",
  id: "order_state",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: "All States",
    },
    ...DSP_ORDER_STATE_OPTIONS.map((state) => ({ label: state.label, value: state.value })),
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (order, filterValue) => {
    if (filterValue !== "all") {
      return order.order_state === filterValue;
    }
    return true;
  },
};

export const DSP_PRODUCT_CONVERSION_TYPE_FILTER = {
  label: "Conversion Type",
  id: "conversion_type",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: "All Conversion Types",
    },
    ...DSP_PRODUCT_CONVERSION_TYPE_OPTIONS.map((status) => ({ label: status.label, value: status.value })),
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (order, filterValue) => {
    if (filterValue !== "all") {
      return order.conversion_type === filterValue;
    }
    return true;
  },
};
